module.exports = __webpack_public_path__ + "static/SSTArabic-Medium-3d3518c5fce4ede36ab641b4af6e6360.otf";